// Shared design-time dataset preview semantics. These values are deliberately
// deterministic placeholders, matching Legend's existing preview convention;
// they are never presented as live device data.
const TYPE_SAMPLE_RANGES = {
    temperature: [18, 28],
    humidity: [30, 65],
    power: [50, 500],
    energy: [0.5, 12],
    pressure: [990, 1030],
    voltage: [210, 240],
    current: [0.1, 10],
    battery: [10, 100],
    illuminance: [50, 2000],
    percentage: [0, 100],
    other: [0, 100],
}

export function datasetSampleValue(type, seriesIndex) {
    const [min, max] = TYPE_SAMPLE_RANGES[type] ?? TYPE_SAMPLE_RANGES.other
    const frac = (seriesIndex * 0.37 + 0.5) % 1
    return min + (max - min) * frac
}

export function datasetPlaceholderStatValue(type, seriesIndex, kind) {
    const [min, max] = TYPE_SAMPLE_RANGES[type] ?? TYPE_SAMPLE_RANGES.other
    const span = max - min
    switch (kind) {
        case 'min': return min + span * 0.05
        case 'max': return max - span * 0.05
        case 'avg': return min + span * 0.5
        default: return datasetSampleValue(type, seriesIndex)
    }
}

/**
 * Use an actual current statistic when one is available. Otherwise use the
 * same deterministic current placeholder used by the existing Legend preview.
 */
export function datasetSeriesPreviewValue(dataset, series, seriesIndex) {
    const rawCurrent = series?.stats?.current
    const current = Number(rawCurrent)
    if (rawCurrent !== null && rawCurrent !== undefined && rawCurrent !== '' && Number.isFinite(current)) return current
    return datasetSampleValue(dataset?.type, seriesIndex)
}
